import { NgModule } from '@angular/core';
import { StepperComponent } from './stepper.component';
import { CdkStepperModule } from '@angular/cdk/stepper';

@NgModule({
  imports: [StepperComponent],
  exports: [StepperComponent, CdkStepperModule],
})
export class StepperModule {}
